import { GridColDef } from '@mui/x-data-grid-pro';

import { ICredential } from 'common/src/types/interfaces';

import addDateColumnProps from 'portal/src/components/common/tables/addDateColumnProps';
import addTriStateColumnProps from 'portal/src/components/common/tables/addTriStateColumnProps';

const getGridColumns: () => GridColDef[] = () => [
  {
    field: 'utilityName',
    headerName: 'Utility',
    flex: 1,
    valueGetter: (_value, row: ICredential) => row.utility?.name,
    sortComparator: (value1, value2) =>
      (value1 ?? '').localeCompare(value2 ?? ''),
  },
  {
    field: 'username',
    headerName: 'Username',
    flex: 1,
  },
  { field: 'loginUrl', headerName: 'Login URL', flex: 1 },
  {
    field: 'invalidAt',
    headerName: 'Status',
    ...addTriStateColumnProps({
      getLabel: (row: ICredential) =>
        row.invalidAt ? 'Invalid' : row.lastLogin ? 'Active' : '-',
      valueOptions: ['-', 'Active', 'Invalid'],
      colors: [undefined, 'success', 'error'],
    }),
  },
  {
    field: 'lastLogin',
    ...addDateColumnProps('Last Login', 160, 'Ppp'),
  },
];

export default getGridColumns;
